export default {
    ERROR: {
        CODE_UNAVAILABLE: [
            "พบปัญหาบางอย่างเกิดขึ้น โปรดลองใหม่อีกครั้ง",
            "There is an error occurred. Please try again later."
        ],
        UPDATE_PAYMENT: {
            ORDER_NOT_FOUND: [
                "ไม่พบหมายเลขการสั่งซื้อที่ระบุ รบกวนตรวจสอบหมายเลขการสั่งซื้อของคุณลูกค้าแล้วลองใหม่อีกครั้งค่ะ",
                "The order number is not found. Please check the number and try to submit again."
            ],
            ORDER_PAID: [
                "สถานะของคำสั่งซื้อไม่ถูกต้อง เนื่องจากพบการชำระเงินหรือถูกยกเลิกแล้วค่ะ",
                "The order status is not waiting for payment. It might be paid or cancelled."
            ]
        },
        TRACK_ORDER: {
            PERMISSION_NOT_ALLOWED: [
                "ขออภัยค่ะ หมายเลขการสั่งซื้อของท่านไม่ตรงกับอีเมลการสั่งซื้อ กรุณากรอกใหม่อีกครั้งค่ะ",
                "Sorry, order number or order e-mail was wrong"
            ]
        },
        FORM: {
            THE1: {
                MISSING: ["โปรดกรอกหมายเลขโทรศัพท์หรือสมาชิกและกดยืนยันค่ะ", "Please enter mobile phone no. or member id and click verify"]
            },
            FIRST_NAME: {
                MISSING: ["โปรดกรอกชื่อจริงเพื่อสิทธิประโยชน์ของท่านค่ะ", "Please enter your first name"]
            },
            LAST_NAME: {
                MISSING: ["โปรดกรอกนามสกุลเพื่อสิทธิประโยชน์ของท่านค่ะ", "Please enter your last name"]
            },
            DOB: {
                MISSING: ["โปรดกรอกวันเดือนปีเกิดของท่านค่ะ", "Please enter your date of birth"]
            },
            EMAIL: {
                MISSING: ["โปรดกรอกอีเมลล์ของท่านค่ะ", "Please enter your email"],
                INVALID: ["อีเมลล์ไม่ถูกต้อง โปรดตรวจสอบค่ะ", "Yuor email is incorrect. Please check your email."],
            },
            TELEPHONE: {
                MISSING: ["โปรดกรอกหมายเลขโทรศัพท์มือถือค่ะ", "Please enter your mobile phone"],
            },
            IDCARD: {
                MISSING: ["โปรดกรอกหมายเลขบัตรประจำตัวประชาชนของท่านค่ะ", "Please enter your ID Card No. or Passport No."]
            },
            ADDRESS: {
                MISSING: ["โปรดกรอกที่อยู่ของท่านค่ะ", "Please enter your contact address."]
            },
            POSTAL: {
                MISSING: ["โปรดกรอกหมายเลขไปรษณีย์ของท่านค่ะ", "Please enter your postal code."]
            },
            SUBDISTRICT: {
                MISSING: ["โปรดกรอกแขวงหรือตำบลของท่านค่ะ", "Please enter your subdistrict."]
            },
            DISTRICT: {
                MISSING: ["โปรดกรอกเขตหรืออำเภอของท่านค่ะ", "Please enter your district."]
            },
            PROVINCE: {
                MISSING: ["โปรดกรอกจังหวัดของท่านค่ะ", "Please enter your province."]
            },
            COUNTRY: {
                MISSING: ["โปรดกรอกจประเทศของท่านค่ะ", "Please enter your province."]
            },
            IDCOPY_IMG: {
                MISSING: ["โปรดแนบสำเนาบัตรประจำตัวประชาชนของท่านค่ะ", "Please attach your copy of id card or passport"]
            },
            RECEIPT_ID: {
                MISSING: ["โปรดระบุหมายเลขใบเสร็จค่ะ", "Please enter your receipt number"]
            },
            RECEIPT_AMOUNT: {
                MISSING: ["โปรดระบุยอดใช้จ่ายสุทธิใบเสร็จค่ะ", "Please enter your receipt amount"]
            },
            RECEIPT: {
                MISSING: ["โปรดแนบรูปใบเสร็จของท่านค่ะ", "Please attach your receipt image"]
            }
        },
        // Item 01b — the backend's typed code for the resend quota
        // (`services/authErrors.js` VerificationResendThrottled). Clients branch
        // on `code`, never on message text.
        VERIFICATION_RESEND_THROTTLED: ["ขอลิงก์ถี่เกินไปค่ะ กรุณารอสักครู่แล้วลองใหม่อีกครั้ง", "That's a lot of requests in a short time. Please wait a moment and try again."],
        FB_AUTH: ["พบข้อผิดพลาดค่ะ โปรดลองใหม่อีกครั้งค่ะ หรือใช้วิธีการเข้าสู่ระบบด้วยอีเมลล์ค่ะ", "Something went wrong with Facebook Login. Please try again or use BEAUTRIUM login."],
        AUTH: {
            "auth/invalid-email": ["อีเมลล์หรือรหัสผ่านไม่ถูกต้องค่ะ โปรดตรวจสอบและลองใหม่อีกครั้งค่ะ", "Email or password is wrong."],
            "auth/user-disabled": ["ผู้ใช้นี้ถูกระงับการใช้งานหรือถูกลบแล้วค่ะ", "This account has been disabled or deleted."],
            "auth/user-not-found": ["ไม่พบผู้ใช้อีเมลล์นี้ โปรดลองใหม่อีกครั้งหรือสมัครสมาชิกใหม่ค่ะ", "User's not found for this email. Please try again or sign up."],
            "auth/wrong-password": ["อีเมลล์หรือรหัสผ่านไม่ถูกต้องค่ะ โปรดตรวจสอบและลองใหม่อีกครั้งค่ะ", "Email or password is wrong."],
            "auth/weak-password": ["รหัสผ่านไม่ปลอดภัยค่ะ กรุณาตั้งรหัสผ่านใหม่", "Password is too weak. Please enter a strong password."],
            "auth/missing-android-pkg-name": ["ไม่พบ Android Pkg Name ค่ะ โปรดแจ้งเจ้าหน้าที่", "Missing Android PKG Name. Please inform our staff to further help."],
            "auth/missing-continue-uri": ["ไม่พบ URI โปรดแจ้งเจ้าหน้าที่", "Missing continue uri. Please inform our staff for further help."],
            "auth/missing-ios-bundle-id": ["ไม่พบ iOS Bundle ID ค่ะ โปรดแจ้งเจ้าหน้าที่", "Missing iOS Bundle ID. Please inform our staff for further help."],
            "auth/invalid-continue-uri": ["Uri ไม่ถูกต้อง โปรดแจ้งเจ้าหน้าที่", "Invalid continue uri. Please inform our staff for further help."],
            "auth/unauthorized-continue-uri": ["ไม่อนุญาติ Uri นี้ โปรดแจ้งเจ้าหน้าที่", "The Uri is not allowed. Please inform our staff for further help."],
            // Not a Firebase code. Raised by `assets/firebase.js` when the lazily
            // loaded Firebase chunk cannot be downloaded or initialised, so the
            // failure reaches the user through the same ERROR.AUTH.<code> path.
            "auth/module-load-failed": ["ไม่สามารถโหลดระบบเข้าสู่ระบบได้ค่ะ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตแล้วลองใหม่อีกครั้งค่ะ", "We couldn't load the sign-in module. Please check your connection and try again."],
            // Item 01b. Both of these arrive at /auth/action and NEITHER is the
            // customer's fault, so neither is worded as one: an expired link is
            // ordinary, and an "already used" link is what a mail client's link
            // prefetcher produces — the customer very probably IS verified. Both
            // states offer a resend and a "check again", so neither dead-ends.
            "auth/expired-action-code": ["ลิงก์ยืนยันหมดอายุแล้วค่ะ กรุณากดปุ่มด้านล่างเพื่อขอลิงก์ใหม่", "This verification link has expired. Tap below to get a new one."],
            "auth/invalid-action-code": ["ลิงก์นี้ถูกใช้ไปแล้วหรือไม่ถูกต้องค่ะ หากคุณยืนยันแล้ว กดปุ่มด้านล่างเพื่อตรวจสอบสถานะได้เลยค่ะ", "This link has already been used or isn't valid. If you've already verified, tap below to check your status."],
            // Not a Firebase code. Raised by FirebaseAction when the URL carries
            // no oobCode/mode at all, e.g. a hand-edited or truncated link.
            "auth/missing-action-code": ["ลิงก์ไม่สมบูรณ์ค่ะ กรุณาขอลิงก์ใหม่อีกครั้ง", "This link is incomplete. Please request a new one."],
            // Not a Firebase code either: a `mode` we do not handle.
            "auth/unsupported-action-type": ["ไม่รองรับการดำเนินการนี้ค่ะ กรุณาติดต่อเจ้าหน้าที่", "We can't handle this type of link. Please contact us."],
            "auth/invalid-oob-code": ["รหัสยืนยันไม่ถูกต้องหรือหมดอายุค่ะ กรุณาขอรหัสใหม่อีกครั้ง", "This code is invalid or has expired. Please request a new one."],
        }
    }
}